const initState = {
  contestData: [],
  brandAmbassodarContestData: [],
  brandAmbassodarContestLastDocument: null,
  brandAmbassodarContestHasMoreDocument: true,
  lastDocument: null,
  hasMoreDocument: true,
  brandAmbassadorParticipants: [],
  brandAmbassadorAthleteParticipants: [],
  brandAmbassadorEliminatedParticipants: [],
  brandAmbassadorVoters: [],
  suggestedAthlete: [],
  lastDocumentSuggestedAthlete: null,
  hasMoreSuggestedAthlete: true,
  contestOrganizer: null,
  contestDetails: {
    data: [],
    lastVisible: null,
    hasMore: true,
  },
};

const contestReducer = (state = initState, action) => {
  switch (action.type) {
    case "SPORT_BADGE_REWARD":
      return {
        ...state,
        contestData: state.contestData.map((items) =>
          items.id == action.payload.contestId
            ? {
                ...items,
                rewardedAmount: action.payload.sportBadgeReward,
                leaderData: action.payload.leaderData,
                qrCode: action.payload.qrCode,
                status: "rewarded",
              }
            : items
        ),
      };
    case "ADD_ATHLETE_IN_SPORT_CONTEST":
      return {
        ...state,
        contestData: state.contestData.map((items) =>
          items.id == action.payload.contestId
            ? { ...items, participantList: action.payload.athleteList }
            : items
        ),
      };
    case "GET_SUGGESTED_ATHLETES":
      return {
        ...state,
        suggestedAthlete: action.payload.data,
        lastDocumentSuggestedAthlete: action.payload.lastDocument,
        hasMoreSuggestedAthlete: action.payload.hasMoreDocument,
      };
    case "MORE_GET_SUGGESTED_ATHLETES":
      return {
        ...state,
        suggestedAthlete: [...state.suggestedAthlete, ...action.payload.data],
        lastDocumentSuggestedAthlete: action.payload.lastDocument,
        hasMoreSuggestedAthlete: action.payload.hasMoreDocument,
      };
    case "GET_VOTERS":
      return {
        ...state,
        brandAmbassadorVoters: action.payload,
      };
    case "GET_PARTICIPANTS":
      return {
        ...state,
        brandAmbassadorAthleteParticipants: action.payload,
      };
    case "GET_BRANDAMBASSADOR_PARTICIPANTS":
      return {
        ...state,
        brandAmbassadorParticipants: action.payload,
      };
    case "GET_BRANDAMBASSADOR_ELIMINATED_PARTICIPANTS":
      return {
        ...state,
        brandAmbassadorEliminatedParticipants: action.payload,
      };
    case "GET_CONTEST":
      return {
        ...state,
        contestData: action.payload.contestData,
        hasMoreDocument: action.payload.hasMoreDocuments,
        lastDocument: action.payload.lastDocument,
      };
    case "FETCH_CONTESTS_SUCCESS":
      return {
        ...state,
        contestData: action.payload.isLoadingMore
          ? [...state.contestData, ...action.payload.data]
          : action.payload.data,
        lastDocument: action.payload.lastVisible,
        hasMoreDocument: action.payload.hasMore,
      };
    case "UPDATE_CONTEST_STATUS_SUCCESS":
      return {
        ...state,
        contestData: state.contestData.filter(
          (contest) => contest.id !== action.payload.id
        ),
      };
    case "GET_BRAND_AMBASSODAR_CONTEST":
      return {
        ...state,
        brandAmbassodarContestData: action.payload.contestData,
        brandAmbassodarContestHasMoreDocument: action.payload.hasMoreDocuments,
        brandAmbassodarContestLastDocument: action.payload.lastDocument,
      };
    case "FETCH_CONTESTS_ORGANIZER_SUCCESS":
      return {
        ...state,
        contestOrganizer: action.payload,
      };
    case "FETCH_CONTESTS_DETAILS_SUCCESS":
      return {
        ...state,
        contestDetails: {
          data: action.payload.isLoadingMore
            ? [...state.contestDetails.data, ...action.payload.data]
            : action.payload.data,
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
        },
      };
    default:
      return {
        ...state,
      };
  }
};
export default contestReducer;
